export default __webpack_public_path__ + "static/media/cloudtail.f8992877.png";